export default "__VITE_PUBLIC_ASSET__ebbd4cc7__"